module.exports = __webpack_public_path__ + "img/bland.20c5c452.png";